import { render, staticRenderFns } from "./View-Teacher.vue?vue&type=template&id=3710ff10&scoped=true"
import script from "./View-Teacher.vue?vue&type=script&lang=js"
export * from "./View-Teacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710ff10",
  null
  
)

export default component.exports